<i18n>
{
  "en":{
    "Loading": "Loading in progress"
  },
  "fr":{
    "Loading": "Chargement en cours"
  }
}
</i18n>

<template>
  <transition name="loading-fade">
    <div
      v-if="isActive"
      id="loading"
      class="loading-screen">
      <div class="d-flex align-items-center h-100">
        <div class="container container-sm">
          <h1
            v-t="'Loading'"
            class="text-center"/>
          <div class="text-center">
            <span class="pulser"/>
            <span
              class="pulser"
              style="animation-delay: 0.13s;"/>
            <span
              class="pulser"
              style="animation-delay: 0.26s;"/>
            <span
              class="pulser"
              style="animation-delay: 0.39s;"/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('loading', ['isActive']),
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/_includes.scss";

.loading-fade-enter-active {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  opacity: 0;
  animation-name: fadeIn;
}

.loading-fade-leave-active {
  animation-duration: 0.2s;
  opacity: 0;
  animation-fill-mode: both;
  animation-name: fadeOut;
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: $gray-300;
}

@keyframes pulse-animation {
  0%,
  100% {
    transform: scale(1);
  }
  35%,
  65% {
    transform: scale(0.3);
  }
}

.pulser {
  background-color: $body-color;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.25rem;
  border-radius: 100%;
  display: inline-block;
  animation-name: pulse-animation;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}
</style>
